import { z } from 'zod';
import { AppointmentReferralReviewSchema } from './AppointmentReferralReviewSchema';
import { dateValidation, coerceNumber } from '../../validation';

export const AppointmentConclusionSchema = z.object({
  date: dateValidation().optional(),
  notesToPatient: z.string().optional(),
  // Optionally a doctor can refer (suggest) an appointment to a specialist.
  // The specialist should approve it and then manually go to Healee and create an appointment.
  // https://miro.com/app/board/uXjVMyBaM2M=/
  requestedReferral: z
    .object({
      services: z.array(coerceNumber(z.number())).optional(),
      notes: z.string().optional(), // doctor notes
      followUpRequired: z.boolean().optional(),
      withinWeeks: z.string().optional(),
      review: AppointmentReferralReviewSchema.optional(),
    })
    .optional(),
});

export type AppointmentConclusion = z.infer<typeof AppointmentConclusionSchema>;
